package com.downdogapp.client.widget

import com.downdogapp.*
import kotlinx.browser.window
import kotlin.math.sqrt

object Animation {

  // Source: https://javascript.info/js-animation
  fun animate(animationLength: Duration,
              interpolation: (Double) -> Double = Interpolation.LINEAR,
              onFinished: () -> Unit = {},
              onStep: (interpolatedValue: Double) -> Boolean) {

    // Use this time (double) for compatibility with JS animation engine
    // See https://developer.mozilla.org/en-US/docs/Web/API/window/requestAnimationFrame
    val startTime = window.performance.now()

    fun animateInner(time: Double) {
      val timeFraction =
        if (animationLength.millis == 0L)
          1.0
        else
          ((time - startTime) / animationLength.millis).coerceIn(0.0..1.0)

      val progress = interpolation(timeFraction)

      if (onStep(progress)) {
        if (timeFraction < 1) {
          window.requestAnimationFrame { animateInner(it) }
        } else {
          onFinished()
        }
      }
    }
    window.requestAnimationFrame { animateInner(it) }
  }
}

object Interpolation {

  val LINEAR = { timeFraction: Double -> timeFraction }
  val SQUARE_ROOT = { timeFraction: Double -> sqrt(timeFraction) }
}
